const BASE_LOGOUT_KEYS = ["targetApp", "tg_expirydate", "subscribedAppsAccess"];

export async function logoutCleanUp(iDB) {
  localStorage.removeItem("tgt");
  localStorage.removeItem("savedreferrer");
  localStorage.removeItem("lastVisited");
  Object.keys(sessionStorage).forEach((key) => {
    if (key.endsWith("LastLoginEvent")) {
      sessionStorage.removeItem(key);
    }
    if (key.endsWith("zipStarted")) {
      sessionStorage.removeItem(key);
    }
    if (key.endsWith("workersStarted")) {
      sessionStorage.removeItem(key);
    }
    if (key.endsWith("downloadIDBProgress")) {
      sessionStorage.removeItem(key);
    }
    if (key.endsWith("downloadZipProgress")) {
      sessionStorage.removeItem(key);
    }
  });
  await iDB.clear(); // cleared idbKeys
  console.log("---cleared idbKeys on logout");
}

export function clearUpStorage() {
  clearLocalStorageKeys(BASE_LOGOUT_KEYS);
  sessionStorage.clear();
}

export function clearMsalKeys() {
  const msalKeysToRemove = Object.keys(localStorage).filter(
    (key) => key.startsWith("msal") || key.includes(import.meta.env.REACT_APP_B2C_AUTHORITYDOMAIN),
  );

  clearLocalStorageKeys(msalKeysToRemove);
}

export const clearLocalStorageKeys = (keys) => {
  keys.forEach((key) => {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  });
};
